export default {
    DEFAULT: 'unknown_error',
    ORIGIN_NOT_ALLOWED: 'origin_not_allowed',
    EVENT_DATA_REQUIRED: 'event_data_required',
    ACTION_NOT_DEFINED: 'action_not_defined',
    TIMEOUT: 'timeout',
    FORBIDDEN: 'forbidden',
    UNAUTHORIZED: 'unauthorized',
    THIRD_PARTY_DISABLED: 'third_party_cookies_disabled'
};



// WEBPACK FOOTER //
// ./static_source/js/errors.js